/**
 * Read time zone name from the broser and returns it as a string
 */
export function readBrowserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
